import { DateTime } from 'luxon';

import { AlertSeverityStoreModelEnum } from '@domain/alerting/alerting.enums';

import { SortDirectionStoreModelEnum } from '@shared/enums/sort-direction.enum';

export const compareByDateString = (a: string | undefined, b: string | undefined, sortDirection: SortDirectionStoreModelEnum): number => {
  if (!a && !b) {
    return 0;
  }
  if (!a) {
    return 1;
  }
  if (!b) {
    return -1;
  }
  const aDate = DateTime.fromISO(a);
  const bDate = DateTime.fromISO(b);
  let result = aDate.toMillis() - bDate.toMillis();
  if (sortDirection === SortDirectionStoreModelEnum.Desc) {
    result = -result;
  }
  return result;
};

export const compareByNumber = (a: number | undefined, b: number | undefined, sortDirection: SortDirectionStoreModelEnum): number => {
  if (!a && !b) {
    return 0;
  }
  if (!a) {
    return 1;
  }
  if (!b) {
    return -1;
  }
  let result = a - b;
  if (sortDirection === SortDirectionStoreModelEnum.Desc) {
    result = -result;
  }
  return result;
};

export const compareByString = (a: string | undefined, b: string | undefined, sortDirection: SortDirectionStoreModelEnum): number => {
  let result = sortStringsAsc(a, b);

  if (sortDirection === SortDirectionStoreModelEnum.Desc) {
    result = -result;
  }

  return result;
};

export const sortStringsAsc = (a: string | undefined, b: string | undefined): number => {
  return !a && !b ? 0 : a && !b ? -1 : !a && b ? 1 : a!.localeCompare(b!);
};

export const sortSitesByName = <TSite extends { id: string; name: string }>(sites: TSite[]): TSite[] => {
  return [...sites].sort((a, b) => sortStringsAsc(a.name, b.name) || sortStringsAsc(a.id, b.id));
};

export const compareBySeverity = (
  a: AlertSeverityStoreModelEnum | undefined,
  b: AlertSeverityStoreModelEnum | undefined,
  sortDirection: SortDirectionStoreModelEnum
): number => {
  const order: AlertSeverityStoreModelEnum[] = [
    AlertSeverityStoreModelEnum.Info,
    AlertSeverityStoreModelEnum.Warning,
    AlertSeverityStoreModelEnum.Critical,
  ];

  if (!a && !b) {
    return 0;
  }

  if (!a) {
    return 1;
  }

  if (!b) {
    return -1;
  }

  const aIndex = order.indexOf(a);
  const bIndex = order.indexOf(b);
  let result = aIndex - bIndex;
  if (sortDirection === SortDirectionStoreModelEnum.Desc) {
    result = -result;
  }
  return result;
};
